<!--预览图片-->
<template>
  <div>
    <iframe id="preViewIframe"
            :src="fileUrl"
            frameborder="0"
            height="500"
            width="960"></iframe>
  </div>
</template>

<script>
import { file } from '@/api/file'
export default {
  name: '',
  props: ['file'],
  components: {},
  data () {
    return {
      fileUrl: ''
    }
  },
  computed: {},
  mounted () {
  },
  methods: {
    getUrl () {
      this.fileUrl = ''
      if (!this.file) { return false }
      var data = new FormData()
      data.append('file', this.file)
      file.transferPDF(data).then(res => {
        const ext = this.file.name.substring(this.file.name.lastIndexOf('.') + 1)
        if (ext === 'docx') {
          this.fileUrl = window.URL.createObjectURL(new Blob([res], { type: 'application/pdf' }))
        } else if (ext === 'doc') {
          this.fileUrl = window.URL.createObjectURL(new Blob([res], { type: 'text/html' }))
          let setTime = setTimeout(() => {
            clearTimeout(setTime)
            let dom = document.getElementById('preViewIframe')
            let body = dom.contentWindow.document.getElementsByTagName('body')
            body = body[0]
            body.style['width'] = '960px'
            body.style['overflow-x'] = 'hidden'
            body.style['word-break'] = 'break-all'
          }, 1000)
        }
      })
    }
  }
}
</script>
<style lang='less' scoped>
</style>
